import { ReviewApi, ReviewQueueListResponse, ReviewQueueItemType } from 'we-tree-api-client/v2';

import { getApiConfiguration } from '@/services/SessionService';
import { ApiResult, withApiSetup } from './apiWrapper';

export interface ListReviewQueueOptions {
  itemType?: ReviewQueueItemType;
  page?: number;
  pageSize?: number;
}

class WrappedReviewApi {
  async listReviewQueue(
    familyId: string,
    options: ListReviewQueueOptions = {}
  ): Promise<ApiResult<ReviewQueueListResponse>> {
    return withApiSetup(
      (config) => new ReviewApi(config),
      getApiConfiguration,
      (api) => api.listReviewQueue(familyId, options.itemType, options.page, options.pageSize)
    );
  }
}

export const reviewApi = new WrappedReviewApi();

export default reviewApi;
